import * as React from 'react';

const NewWindow = ({ className }) => {
    return (<>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className={`docs-icon ${className || ''}`} xmlns="http://www.w3.org/2000/svg">
            <path d="M16.875 8.125L16.8742 3.12578L11.875 3.125M10.625 9.375L16.875 3.125M14.375 10.625V16.25C14.375 16.4158 14.3092 16.5747 14.1919 16.6919C14.0747 16.8092 13.9158 16.875 13.75 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V6.25C3.125 6.08424 3.19085 5.92527 3.30806 5.80806C3.42527 5.69085 3.58424 5.625 3.75 5.625H9.375" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    </>)
}

export default NewWindow;